module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/user-form/user-form.component.scss
// module id = ./src/app/ui/user-form/user-form.component.scss
// module chunks = main